import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslationService } from './modules/i18n';
// language list
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { locale as caLang } from './modules/i18n/vocabs/ca';
// Vocabularios por pantalla, fusionados sobre los generales.
import { locale as userDetailEs } from './modules/i18n/vocabs/user-detail/es';
import { locale as userDetailEn } from './modules/i18n/vocabs/user-detail/en';
import { locale as userDetailCa } from './modules/i18n/vocabs/user-detail/ca';
import { locale as userDetailTabsEs } from './modules/i18n/vocabs/user-detail-tabs/es';
import { locale as userDetailTabsEn } from './modules/i18n/vocabs/user-detail-tabs/en';
import { locale as userDetailTabsCa } from './modules/i18n/vocabs/user-detail-tabs/ca';
import { locale as pvpPromosEs } from './modules/i18n/vocabs/pvp-promos/es';
import { locale as pvpPromosEn } from './modules/i18n/vocabs/pvp-promos/en';
import { locale as pvpPromosCa } from './modules/i18n/vocabs/pvp-promos/ca';
import { locale as tripPromosEs } from './modules/i18n/vocabs/trip-promos/es';
import { locale as tripPromosEn } from './modules/i18n/vocabs/trip-promos/en';
import { locale as tripPromosCa } from './modules/i18n/vocabs/trip-promos/ca';
import { locale as zoneAdSettingsEs } from './modules/i18n/vocabs/zone-ad-settings/es';
import { locale as zoneAdSettingsEn } from './modules/i18n/vocabs/zone-ad-settings/en';
import { locale as zoneAdSettingsCa } from './modules/i18n/vocabs/zone-ad-settings/ca';
import { locale as zoneAdsEs } from './modules/i18n/vocabs/zone-ads/es';
import { locale as zoneAdsEn } from './modules/i18n/vocabs/zone-ads/en';
import { locale as zoneAdsCa } from './modules/i18n/vocabs/zone-ads/ca';
import { locale as rideBookingsEs } from './modules/i18n/vocabs/ride-bookings/es';
import { locale as rideBookingsEn } from './modules/i18n/vocabs/ride-bookings/en';
import { locale as rideBookingsCa } from './modules/i18n/vocabs/ride-bookings/ca';
import { locale as rideReviewsEs } from './modules/i18n/vocabs/ride-reviews/es';
import { locale as rideReviewsEn } from './modules/i18n/vocabs/ride-reviews/en';
import { locale as rideReviewsCa } from './modules/i18n/vocabs/ride-reviews/ca';
import { locale as referralsEs } from './modules/i18n/vocabs/referrals/es';
import { locale as referralsEn } from './modules/i18n/vocabs/referrals/en';
import { locale as referralsCa } from './modules/i18n/vocabs/referrals/ca';
import { locale as pushNotificationsEs } from './modules/i18n/vocabs/push-notifications/es';
import { locale as pushNotificationsEn } from './modules/i18n/vocabs/push-notifications/en';
import { locale as pushNotificationsCa } from './modules/i18n/vocabs/push-notifications/ca';
import { locale as marketingUsersEs } from './modules/i18n/vocabs/marketing-users/es';
import { locale as marketingUsersEn } from './modules/i18n/vocabs/marketing-users/en';
import { locale as marketingUsersCa } from './modules/i18n/vocabs/marketing-users/ca';
import { locale as userListEs } from './modules/i18n/vocabs/user-list/es';
import { locale as userListEn } from './modules/i18n/vocabs/user-list/en';
import { locale as userListCa } from './modules/i18n/vocabs/user-list/ca';
import { BO_AUTH_LOCALES, BO_CORE_LOCALES } from '@bo/i18n';
import { locale as driversFleetEs } from './modules/i18n/vocabs/drivers-fleet/es';
import { locale as driversFleetEn } from './modules/i18n/vocabs/drivers-fleet/en';
import { locale as driversFleetCa } from './modules/i18n/vocabs/drivers-fleet/ca';
import { locale as driversFleetPanelEs } from './modules/i18n/vocabs/drivers-fleet-panel/es';
import { locale as driversFleetPanelEn } from './modules/i18n/vocabs/drivers-fleet-panel/en';
import { locale as driversFleetPanelCa } from './modules/i18n/vocabs/drivers-fleet-panel/ca';
import { locale as driversFleetOpsEs } from './modules/i18n/vocabs/drivers-fleet-ops/es';
import { locale as driversFleetOpsEn } from './modules/i18n/vocabs/drivers-fleet-ops/en';
import { locale as driversFleetOpsCa } from './modules/i18n/vocabs/drivers-fleet-ops/ca';
import { locale as eventsEs } from './modules/i18n/vocabs/events/es';
import { locale as eventsEn } from './modules/i18n/vocabs/events/en';
import { locale as eventsCa } from './modules/i18n/vocabs/events/ca';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';

@Component({
    // tslint:disable-next-line:component-selector
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'body[root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private router: Router,
  ) {
    // register translations
    // Primero los diccionarios compartidos (@bo/i18n); los del dashboard se combinan encima.
    this.translationService.loadTranslations(
      ...BO_CORE_LOCALES,
      ...BO_AUTH_LOCALES,
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang,
      caLang,
      userDetailEs,
      userDetailEn,
      userDetailCa,
      userDetailTabsEs,
      userDetailTabsEn,
      userDetailTabsCa,
      pvpPromosEs,
      pvpPromosEn,
      pvpPromosCa,
      tripPromosEs,
      tripPromosEn,
      tripPromosCa,
      zoneAdSettingsEs,
      zoneAdSettingsEn,
      zoneAdSettingsCa,
      zoneAdsEs,
      zoneAdsEn,
      zoneAdsCa,
      rideBookingsEs,
      rideBookingsEn,
      rideBookingsCa,
      rideReviewsEs,
      rideReviewsEn,
      rideReviewsCa,
      referralsEs,
      referralsEn,
      referralsCa,
      pushNotificationsEs,
      pushNotificationsEn,
      pushNotificationsCa,
      marketingUsersEs,
      marketingUsersEn,
      marketingUsersCa,
      userListEs,
      userListEn,
      userListCa,
      driversFleetEs,
      driversFleetEn,
      driversFleetCa,
      driversFleetPanelEs,
      driversFleetPanelEn,
      driversFleetPanelCa,
      driversFleetOpsEs,
      driversFleetOpsEn,
      driversFleetOpsCa,
      eventsEs,
      eventsEn,
      eventsCa,
    );
  }

  ngOnInit() {
    this.modeService.init();
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => this.releaseStuckModalScrollLock());
  }

  /**
   * Devuelve el scroll al `body` tras navegar.
   *
   * Varias pantallas abren modales NATIVOS de Bootstrap (`new Modal(el).show()`
   * en empleados, incentivos, cupones, flota...). Bootstrap bloquea el scroll
   * poniendo `modal-open` y un `overflow: hidden` en línea sobre el `<body>`, y
   * solo lo suelta en su propio cierre. Si se navega con el modal abierto —un
   * enlace dentro del modal, la sidebar, el botón atrás—, Angular destruye el
   * componente y se lleva el modal del DOM sin que ese cierre llegue a
   * ejecutarse: el bloqueo se queda puesto y la aplicación entera se queda sin
   * scroll (y con el fondo oscuro capturando los clics) hasta recargar.
   *
   * Ninguno de esos componentes cierra su modal en `ngOnDestroy`, así que en
   * lugar de parchear cada uno se limpia aquí, que además cubre los que se
   * añadan después. Solo actúa si NO queda ningún modal visible, para no
   * desbloquear uno que siga abierto legítimamente.
   */
  private releaseStuckModalScrollLock(): void {
    if (document.querySelector('.modal.show')) return;

    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
    document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
  }
}
